var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),(!_vm.isWaiting)?_c('router-view'):_vm._e(),_c('NavbarBottom'),(_vm.$route.name != 'Chat')?_c('NavbarUser'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }